__turbopack_context__.v({
  "accessibility": "PlasmicLoginFormResources-module__aBpZBq__accessibility",
  "compliance": "PlasmicLoginFormResources-module__aBpZBq__compliance",
  "divider": "PlasmicLoginFormResources-module__aBpZBq__divider",
  "divider2": "PlasmicLoginFormResources-module__aBpZBq__divider2",
  "link__eVQn": "PlasmicLoginFormResources-module__aBpZBq__link__eVQn",
  "link__ryei7": "PlasmicLoginFormResources-module__aBpZBq__link__ryei7",
  "link__zdsG": "PlasmicLoginFormResources-module__aBpZBq__link__zdsG",
  "privacyPolicy": "PlasmicLoginFormResources-module__aBpZBq__privacyPolicy",
  "resources": "PlasmicLoginFormResources-module__aBpZBq__resources",
});
